/* eslint-disable @typescript-eslint/naming-convention */
export enum UiCardGroupRenderingEnum {
    Bigtionaer = 'bigtionaer',
    IconLink = 'icon-link',
    IconTopHeadline = 'icon-top-headline',
    IconTopHeadlineText = 'icon-top-headline-text',
    IconTopHeadlineTextReadmore = 'icon-top-headline-text-readmore',
    IconLeftHeadlineTextReadmore = 'icon-left-headline-text-readmore',
    ImageTopHeadlineText = 'image-top-headline-text',
    ImageTopHeadlineTextReadmore = 'image-top-headline-text-readmore',
    ImageRightHeadlineTextReadmore = 'image-right-headline-text-readmore',
    ImageAlternatingHeadlineTextReadmore = 'image-alternating-headline-text-readmore',
    HeadlineReadmore = 'headline-readmore',
    HeadlineTextReadmore = 'headline-text-readmore',
}
